import React, { useState }  from 'react'
import axios from 'axios'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export default function MlComment() {
    const [loadingMsg, setLoadingMsg]= useState(false)
    const [res, setRes]= useState('')
    const [userInput, setUserInput] = useState({comment:'This restaurant is good place for family. Food is all affordable and plenty of kids menu.'})
    const onChange2Input = ({ currentTarget: x }) => { setUserInput({ ...userInput, [x.name]: x.value }) }
    const onClick2JudgeComment=async()=>{
        console.log(userInput)
        setLoadingMsg(true)
        try {
            const {data:res} = await axios.post(`${APIURL}/ml/comment`,userInput)
            setRes(res.result)
            setLoadingMsg(false)
        } catch (err) {console.log(err)}
    }
    return (
    <>
    <div className='grid grid-cols-1 md:grid-cols-[250px_auto]'>
    <div className='flex'>
    <div className='flex-col'>
    <ldiv className='text-[9px]'>Review comment:</ldiv>
    <div className='flex'>
    <input className='pl-[2px] border border-gray-800 w-full md:w-[200px] mr-[2px]'  name='comment' type='text' defaultValue='This restaurant is good place for family. Food is all affordable and plenty of kids menu.' onChange={onChange2Input}/>
    <button className='bg-gray-800 hover:bg-gray-700 h-auto pl-[8px] pr-[8px] text-white text-[12px]' onClick={onClick2JudgeComment}>Run</button>
    </div>
    </div>
    </div>
    <div>
    <div className='text-[9px] mb-2'>
    <p>csv data:<br/>
    1000items 63% accuracy level.</p>
    <div  className='bg-gray-100 w-fit p-1'>
    Review	Liked<br/>
    Wow... Loved this place.	1<br/>
    Crust is not good.	0<br/>
    Not tasty and the texture was just nasty.	0<br/>
    ... <br/>
    </div>
    </div>
    </div>
    </div>
    <div className='text-[12px]'>
    <b>ML Result:</b><br/>
    <div className='text-left'>
    {loadingMsg?<p className='flex text-xs'>Please wait for a moment<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>:<>{res==''? <span className='text-gray-400'>Click Calculate to see the result</span>:<>{res}</>}</>}
    </div>
    </div>
    </>
    )
}